<template>
    <section class="app-main">

        
        <div class="top-bar">
            <el-input  v-model="title" @change="handleTitle"  placeholder="输入sku查询" prefix-icon="el-icon-search" clearable style="width:260px;margin:0 20px 15px 0;">

            </el-input>
            <el-date-picker v-model="year" type="year" value-format="yyyy" placeholder="年份搜索" @change="handleYear" style="width:260px;"></el-date-picker>
            <el-button type="success" plain  style="width:120px;margin-left:20px;" @click="onSend()">导出报表</el-button>

        </div>
        
    
        <!-- 商品列表 -->
        <el-card >
            <el-table ref="table" :data="tableData" :cell-style="handleCell" height="580">
                <el-table-column prop="goods_name" label="商品名称"  align="center" min-width="130" show-overflow-tooltip fixed="left"></el-table-column>
                <el-table-column prop="barcode" label="SKU" align="center" min-width="130" fixed="left"> </el-table-column>
                <el-table-column prop="sku_name" label="规格属性"  align="center" > </el-table-column>
                <el-table-column prop="initial_stock" label="初始库存"  align="center" > </el-table-column>

                <el-table-column prop="january"  label="一月销量"  align="center" > </el-table-column>
                <el-table-column prop="february" label="二月销量"  align="center" > </el-table-column>
                <el-table-column prop="march"    label="三月销量"  align="center" > </el-table-column>
                <el-table-column prop="april"    label="四月销量"  align="center" > </el-table-column>
                <el-table-column prop="may"      label="五月销量"  align="center" > </el-table-column>
                <el-table-column prop="june"     label="六月销量"  align="center" > </el-table-column>
                <el-table-column prop="july"     label="七月销量"  align="center" > </el-table-column>
                <el-table-column prop="august"   label="八月销量"  align="center" > </el-table-column>
                <el-table-column prop="september" label="九月销量" align="center" > </el-table-column>
                <el-table-column prop="october"  label="十月销量"  align="center" > </el-table-column>
                <el-table-column prop="october" label="十一月销量" align="center" > </el-table-column>
                <el-table-column prop="december" label="十二月销量" align="center" > </el-table-column>
      
                <el-table-column prop="year_sales_volume" label="年销量"  align="center" ></el-table-column>
                <el-table-column prop="year_avg_price" label="平均销售价"  align="center" ></el-table-column>
                <el-table-column prop="return_goods" label="返货数量"  align="center" ></el-table-column>
                <el-table-column prop="disability" label="反残数量"  align="center" ></el-table-column>
                <el-table-column prop="self_use" label="公司自用"  align="center" ></el-table-column>
                <el-table-column prop="marketing" label="市场部开销"  align="center" ></el-table-column>
                <el-table-column prop="natural_loss" label="自然损耗"  align="center" ></el-table-column>
                <el-table-column prop="man_made_attrition" label="人为损耗"  align="center" ></el-table-column>
                <el-table-column prop="surplus_stock" label="剩余库存"  align="center" ></el-table-column>
                <el-table-column prop="inventory_value" label="剩余库存价值"  align="center" >
                    <template slot-scope="scope"> 
                        <span>{{scope.row.inventory_value.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                
                
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" ></el-pagination>
        </el-card>



    </section>
</template>



<script>
import { report } from '@/api/platform.js'
export default {
    data() {
        return {
            year: '',
            title: '',
            checkItem:[],
           
            tableData:[],
            status:0,
            total:0,
            page:1,

        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page
            }
            if(this.title != ""){
                params.barcode_search = this.title;
            }
            if(this.year != ""){
                params.year_search = this.year;
            }
            report(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [] ;
                }
            })
        },
        // 确认导出
        onSend(){
            if(!this.year){
                this.$message.error('请先选择年份')
                return false
            }
            else
            var a = document.createElement("a");
            a.href = `https://admintapi.moobyyoho.com/finance/transaction-report-export?year_search=${this.year}`;
            a.click();
        },
        // 订单号搜索
        handleTitle(){
            this.year = ''
            this.page = 1
            this.getData()
        },
        // 日期查询搜索
        handleYear(){
            this.title = ''
            this.page  = 1
            this.getData()
        },


        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page;
            this.getData();
            
        },

        // 设置cell 格式
        handleCell(obj ) {
            if([3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25].includes(obj.columnIndex)) {
                if(obj.row[obj.column.property] != 0) {
                    return 'color:red'
                }
            }
        },

      
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
    
}
</style>
